import React from 'react';

type BackgroundImageProps = {
  zIndex: number;
  url: string;
  width?: string;
  height?: string;
};

export const BackgroundImage = ({
  url,
  zIndex,
  width = '100%',
  height = '100%',
}: BackgroundImageProps) => {
  return (
    <div
      style={{
        zIndex: zIndex,
        background: `url(${url}) 35% 100%`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        width: width,
        height: height,
      }}
      className="stacked-image"
    ></div>
  );
};
